"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LightboxImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactCoolPortal = _interopRequireDefault(require("react-cool-portal"));

var _core = require("@chakra-ui/core");

var _StandardImage = require("./StandardImage");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var LightboxImage = function LightboxImage(props) {
  var url = props.url,
      largeImageUrl = props.largeImageUrl,
      alt = props.alt,
      title = props.title,
      isEditMode = props.isEditMode;

  var _usePortal = (0, _reactCoolPortal["default"])({
    defaultShow: false
  }),
      Portal = _usePortal.Portal,
      isShow = _usePortal.isShow,
      show = _usePortal.show,
      hide = _usePortal.hide;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_StandardImage.StandardImage, _extends({}, props, {
    onClick: function onClick() {
      if (!isEditMode) {
        show();
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(Portal, null, /*#__PURE__*/_react["default"].createElement(_core.Modal, {
    isOpen: isShow,
    onClose: hide
  }, /*#__PURE__*/_react["default"].createElement(_core.ModalOverlay, null), /*#__PURE__*/_react["default"].createElement(_core.ModalContent, {
    maxW: "80vw",
    p: "1rem",
    cursor: "zoom-out",
    onClick: function onClick() {
      hide();
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.ModalBody, {
    p: "0"
  }, /*#__PURE__*/_react["default"].createElement(_core.Image, {
    src: largeImageUrl || url,
    w: "100%",
    alt: alt || title || url
  })), title && /*#__PURE__*/_react["default"].createElement(_core.ModalFooter, {
    textAlign: "center",
    justifyContent: "center",
    fontFamily: "body",
    pt: "1rem",
    pb: "0"
  }, title)))));
};

exports.LightboxImage = LightboxImage;